export const UBO_FLOW_PROCESS_NAME = 'ubos' as const;
